// @ts-ignore
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import PersonalInformationStep from "../../../components/multistep/PersonalInformationStep";
import PaymentStep from "./components/multistep/PaymentStepCheckOut";
import Invoice from "./components/multistep/Invoice";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import { CredentialMapper } from "@sphereon/ssi-types";
import ThankYou from "./components/multistep/ThankYou";

type CheckOutWizardProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
};

const CheckOutWizard: React.FC<CheckOutWizardProps> = (props: CheckOutWizardProps) => {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [mounted, setMounted] = useState(true);

  const getSubjects = (payload: AuthorizationResponsePayload, index: number = 0) => {
    if (payload) {
      const presentation = CredentialMapper.toWrappedVerifiablePresentation(
        Array.isArray(payload.vp_token)
          ? payload.vp_token[0]
          : payload.vp_token!,
      );
      const subjects =
        presentation?.presentation?.verifiableCredential[index].credential
          .credentialSubject!; // Although rare, a VC can have more than one subject
      return subjects;
    }
    return null;
  }

  const authenticateUser = () => {
    if (props.onApply) {
      props.onApply();
    }
  };

  useEffect(() => {
    return () => {
      setActiveStep(0);
      setMounted(true);
    };
  }, []);

  const handleComplete = () => {
    console.log("Form completed!");
    // Handle form completion logic here
    let path = `/hotel`;
    navigate(path);
  };

  const tabChanged = ({
    prevIndex,
    nextIndex,
  }: {
    prevIndex: number;
    nextIndex: number;
  }) => {};

  if (mounted) {
    return (
      <FormWizard
        color={"#aa8453"}
        onComplete={handleComplete}
        onTabChange={tabChanged}
        startIndex={activeStep}
      >
        <FormWizard.TabContent title="Guest Information">
        <PersonalInformationStep    payload={props.payload} useMySSIOnly={true}
            authenticateUser={() => authenticateUser()}
            signalIfValid={() => true}/>
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Pay">
        <PaymentStep payload={props.payload} getPayload={() => null}
            authenticateUser={() => authenticateUser()}
            signalIfValid={() => true}/>
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Invoice">
          <Invoice />
        </FormWizard.TabContent>
      </FormWizard>
    );
  }

  return null;
};

export default CheckOutWizard;
